import React from 'react';
import { HandCoins } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid, Steps } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

const LENDER_TYPES = ['Private Accredited', 'Private Non-Accredited', 'Institutional', 'Syndicate'];

export default function LenderPortalPage() {
  const module = getModule('lender-portal')!;
  return (
    <ModulePageLayout module={module} Icon={HandCoins}>
      <Section title="A Marketplace for Verified Lenders">
        <p className="text-gray-700 leading-relaxed mb-4">
          The 3rd Party Lender System connects verified lenders directly with borrowers across the Bankably
          platform. Onboarding is rigorous — personal details, company registration, KYC documents, and a
          full compliance review before any lender can publish an offer.
        </p>
        <div className="flex flex-wrap gap-2">
          {LENDER_TYPES.map((t) => (
            <span key={t} className="px-3 py-1.5 bg-fuchsia-50 text-fuchsia-800 rounded-full text-sm font-medium border border-fuchsia-200">
              {t}
            </span>
          ))}
        </div>
      </Section>

      <Section title="From Application to Active Loan">
        <Steps
          items={[
            'A lender submits onboarding details and passes compliance review: Under Review → Approved.',
            'Approved lenders publish loan offers — amount range, interest rate, term, currency, and target borrower criteria.',
            'Borrowers matching the criteria apply; the lender reviews and accepts.',
            'The loan is tracked through its lifecycle: Good Standing, Default, Collections, or Pending, with full repayment history.',
          ]}
        />
      </Section>

      <Section title="What Lenders Manage">
        <FeatureGrid
          items={[
            { title: 'Account Lifecycle', body: 'A lender account moves through In-Active → Pending → Approved → Active, with 2FA required throughout.' },
            { title: 'Financial Profile', body: 'Wallet address and tax ID are tracked alongside the lender\'s active account status.' },
            { title: 'Different Limits by Type', body: 'Private accredited, private non-accredited, institutional, and syndicate lenders each have distinct lending limits and regulatory requirements.' },
          ]}
        />
      </Section>
    </ModulePageLayout>
  );
}
